<!--
入力内容表示コンポーネント
単位なしバージョン
 -->
<template>
  <div class="value" :data-test="dataTest">
    {{ value | checkNull }}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    dataTest: String
  },
  filters: {
    checkNull(value) {
      if (value === null) {
        return "--";
      } else {
        return value;
      }
    }
  }
};
</script>

<style scoped>
.value {
  font-weight: bold;
  font-size: 16px;
}
</style>
